import { type HttpPost, mapServerError } from '@/shared/infra/http'
import type { MatchQrSignature } from '@/shared/domain'

type MatchQrSignatureBody = {
  orgId: string
  orgType: 'club' | 'outfitter'
  userId: string
}

export class EdgeMatchQrSignatureRepository {
  constructor(private readonly http: HttpPost) {}

  execute: MatchQrSignature = async ({ requestId, orgId, orgType, userId }) => {
    try {
      await this.http.post<MatchQrSignatureBody, unknown>({
        url: `/signature-requests/${encodeURIComponent(requestId)}/match`,
        body: { orgId, orgType, userId },
      })
    } catch (err) {
      mapServerError(err, {})
    }
  }
}
